import { API_BASE } from '../config';
import type {
  CreateProductRequest,
  ProductDto,
  UpdateProductRequest,
} from '../types/product';

export async function getProducts(categoryId?: number, department?: string): Promise<ProductDto[]> {
  const params = new URLSearchParams();
  if (categoryId !== undefined) params.set('categoryId', String(categoryId));
  if (department !== undefined) params.set('department', department);
  const qs = params.toString();
  const url = qs ? `${API_BASE}/products?${qs}` : `${API_BASE}/products`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<ProductDto[]>;
}

export async function getProduct(id: number): Promise<ProductDto> {
  const res = await fetch(`${API_BASE}/products/${id}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<ProductDto>;
}

export async function createProduct(
  data: CreateProductRequest
): Promise<ProductDto> {
  const res = await fetch(`${API_BASE}/products`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<ProductDto>;
}

export async function updateProduct(
  id: number,
  data: UpdateProductRequest
): Promise<ProductDto> {
  const res = await fetch(`${API_BASE}/products/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<ProductDto>;
}

export interface ProductSearchParams {
  q?: string;
  manufacturer?: string;
  categoryId?: number;
  weightMin?: number;
  weightMax?: number;
  department?: string;
  kashrut?: string;
}

export async function searchProducts(params: ProductSearchParams): Promise<ProductDto[]> {
  const p = new URLSearchParams();
  if (params.q)                           p.set('q',            params.q);
  if (params.manufacturer)                p.set('manufacturer', params.manufacturer);
  if (params.categoryId !== undefined)    p.set('categoryId',   String(params.categoryId));
  if (params.weightMin !== undefined)     p.set('weightMin',    String(params.weightMin));
  if (params.weightMax !== undefined)     p.set('weightMax',    String(params.weightMax));
  if (params.department)                  p.set('department',   params.department);
  if (params.kashrut)                     p.set('kashrut',      params.kashrut);
  const res = await fetch(`${API_BASE}/products/search?${p.toString()}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<ProductDto[]>;
}

export async function getKashrutValues(): Promise<string[]> {
  const res = await fetch(`${API_BASE}/products/kashrut-values`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<string[]>;
}

export async function deleteProduct(id: number): Promise<void> {
  const res = await fetch(`${API_BASE}/products/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
